import { Card, CardContent, Chip, Grid } from '@material-ui/core'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'
import moment from 'moment/moment'
import { ERROR_COLORS, SUCCESS_COLORS, WARNING_COLORS } from 'asterX-UI'
import { useStyles } from './work-list-tasks.styles'

export const WorkListTaskCardMobile = ({ task, onClick, isClosedTasks }) => {
  const classes = useStyles()

  const isOverdue = task?.end
    ? moment().isAfter(moment(task?.end), 'days')
    : false
  const isCurrentDay = task?.end
    ? moment().date() === moment(task?.end).date()
    : false

  const dateColor = isOverdue
    ? ERROR_COLORS[600]
    : isCurrentDay
    ? WARNING_COLORS[600]
    : SUCCESS_COLORS[600]

  return (
    <Card
      className={isOverdue && !isClosedTasks ? classes.overdueCard : ''}
      onClick={() => onClick(task)}
    >
      <CardContent className={classes.taskCardContent}>
        <Grid container>
          <Grid
            item
            container
            alignItems="center"
            justifyContent="space-between"
          >
            <AsterTypography variant="h6">{task?.title || ''}</AsterTypography>

            <AsterTypography
              style={{
                color: dateColor
              }}
            >
              {task?.end ? moment(task.end).format('D MMMM YYYY, HH:mm') : '-'}
            </AsterTypography>
          </Grid>
          <Grid item xs={12} style={{ margin: '6px 0 12px 0' }}>
            <AsterTypography>РЛ {task?.id}</AsterTypography>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 12 }}>
            <AsterTypography>
              {task?.description?.trim() || '-'}
            </AsterTypography>
          </Grid>

          {isOverdue && !isClosedTasks && (
            <Grid item>
              <Chip className={classes.overdueChip} label="Просрочено" />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  )
}
